import { IQuestionnaireService } from './services/QuestionnaireService';
import { ITranslationService }   from './services/TranslationService';

export class QuestionnaireResolver {

    static $inject = [
        '$rootScope',
        '$timeout',
        '$stateParams',
        'QuestionnaireService',
        '$translate',
    ];

    constructor($rootScope,
                $timeout,
                $stateParams:any,
                QuestionnaireService:IQuestionnaireService,
                $translate:angular.translate.ITranslateService) {

        return $translate.onReady().then(() => {
            const waitForTimeoutToInit = () => {
                if (!$rootScope.isAuthServiceLoaded) {
                    return $timeout(waitForTimeoutToInit, 10);
                } else {
                    return $timeout();
                }
            };
            
            return waitForTimeoutToInit()
            .then(function () {
                return QuestionnaireService.get($stateParams.slug, $stateParams.upid);
            });
        });
    }
}
